var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-table-block',{attrs:{"column":_vm.column,"data":_vm.rows,"merge":_vm.merge,"border":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }